import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Process = () => {
  const steps = [
    {
      num: "01",
      title: "Initial Inquiry",
      icon: "MessageSquare",
      desc: "Briefly outline your situation via WhatsApp or Email. Direct and confidential."
    },
    {
      num: "02",
      title: "Assessment",
      icon: "Activity",
      desc: "Rapid evaluation of case feasibility and strategic impact."
    },
    {
      num: "03",
      title: "Intervention",
      icon: "Compass",
      desc: "Execution of the strategic plan and deal navigation."
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-brand-white text-brand-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        
        <div className="text-center mb-24">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Direct Engagement</h2>
          <div className="w-16 h-1.5 bg-brand-gold mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-16 relative">
          {/* Subtle line for desktop */}
          <div className="hidden md:block absolute top-[60px] left-[15%] right-[15%] h-[1px] bg-brand-border z-0"></div>
          
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="relative z-10 flex flex-col items-center text-center"
            >
              <div className="w-28 h-28 bg-white rounded-full flex items-center justify-center mb-8 border-2 border-brand-border shadow-xl shadow-brand-black/5 group hover:border-brand-gold transition-colors">
                <SafeIcon name={step.icon} className="text-4xl text-brand-black" />
              </div>
              <div className="text-brand-gold font-black text-4xl mb-4 opacity-20">{step.num}</div>
              <h3 className="text-2xl font-extrabold mb-4 tracking-tight">{step.title}</h3>
              <p className="text-brand-muted font-light max-w-xs">{step.desc}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Process;